<template>
  <div>
    <el-table
      :data="data"
      style="width: 100%"
      size="medium"
      header-row-class-name="supervision-table-header"
      row-class-name="common-table-row"
      class="is-print-hide common-table"
      border
    >
      <el-table-column label="通用名" prop="drugName"></el-table-column>
      <el-table-column prop="drugSpec" label="规格"></el-table-column>
      <el-table-column label="数量" prop="drugNum">
        <template #default="{ row: { drugNum, drugUnit } }">
          <span>{{ `${drugNum}${drugUnit || ''}` }}</span>
        </template>
      </el-table-column>
      <el-table-column label="药品信息详情" min-width="160px">
        <template #default="{ row }">
          <el-button
            size="small"
            type="text"
            @click="
              gridTableData = [row];
              dialogTableVisible = true;
            "
          >
            查看
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="是否处方药" :min-width="100">
        <template #default="{ row: { isPrescription } }">
          {{ isPrescription | formatPrescription }}
        </template>
      </el-table-column>
      <el-table-column label="销售时间" :min-width="100">
        <template #default="{ row: { orderTime } }">
          {{ orderTime | formatTime }}
        </template>
      </el-table-column>
      <el-table-column label="销售订单号" prop="orderId" :min-width="180">
        <template #default="{ row: { patchedStatus, orderId } }">
          {{ orderId }}
          <el-tooltip class="item" effect="dark" content="订单非销售当日上传" placement="top-start">
            <el-tag type="danger" v-if="patchedStatus == 1" size="mini">补传</el-tag>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="药品信息详情" :visible.sync="dialogTableVisible" center alignFooter="right" width="1000px">
      <div style="padding-bottom: 40px">
        <el-table :data="gridTableData" border>
          <el-table-column property="drugName" label="通用名" width="150"></el-table-column>
          <el-table-column property="drugSpec" label="规格" width="160"></el-table-column>
          <el-table-column property="drugNum" label="数量" width="60"></el-table-column>
          <el-table-column property="drugUnit" label="单位" width="60"></el-table-column>
          <el-table-column property="barCode" label="药品条码" width="160"></el-table-column>
          <el-table-column property="drugManufacturer" label="生产厂家" width="200"></el-table-column>
          <el-table-column property="drugProductBatchNo" label="生产批号" width="120"></el-table-column>
          <el-table-column property="drugValidityPeriod" label="有效期至" width="150">
            <template slot-scope="scope">
              {{ scope.row.drugValidityPeriod | toTime }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'supervisionList',
  props: {
    type: {
      type: String
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogTableVisible: false,
      gridTableData: []
    };
  },
  filters: {
    toTime(val) {
      if (!val) return '--';
      return dayjs(val).format('YYYY-MM-DD');
    },
    formatTime(val) {
      if (!val) return '--';
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
    },
    formatPrescription(val) {
      return val === 1 ? '处方药' : val === 0 ? '非处方药' : '--';
    },
    adaptStatus(val) {
      const statusMap = { 9: '未登记', 1: '已登记', 0: '待登记' };
      return statusMap[val];
    },
    adaptPatchStatus(val) {
      const statusMap = { 1: '补传', 0: '当日上传' };
      return statusMap[val];
    }
  }
};
</script>

<style lang="scss" scoped>
.drug-item {
  position: relative;
  padding: 5px 0;

  .drug-title {
    font-weight: 500;
  }

  &:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #efefef;
  }

  &:last-child {
    &:before {
      display: none;
    }
  }
}

.red {
  color: #eb3c36;
}

.green {
  color: #1e8dff;
}

.yellow {
  color: #ebb436;
}
</style>
